export const wikiPageHrefTypes = {
  cms_carrier_page_index: 'cmsCarrierPageIndex',
  cms_city_page_index: 'cmsCityPageIndex',
  cms_route_page_index: 'cmsRoutePageIndex',
  cms_train_type_page_index: 'cmsTrainTypePageIndex',
  cms_trainstation_page_index: 'cmsTrainStationPageIndex',
};

export const wikiPageRouteTypeNames = {
  cms_carrier_page_index: 'carriers',
  cms_city_page_index: 'cities',
  cms_route_page_index: 'routes',
  cms_train_type_page_index: 'trains',
  cms_trainstation_page_index: 'stations',
};

export default {
  cities: 'cms_city_page',
  routes: 'cms_route_page',
  trains: 'cms_train_type_page',
  stations: 'cms_trainstation_page',
  carriers: 'cms_carrier_page',
};
